import * as React from "react";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

import FilterCheckObjSimple from "../filters/FilterCheckObjSimple";
import FilterCheckObjTree from "../filters/FilterCheckObjTree";
import ModalComponent from "./ModalComponent";
import ColumnsCustomizer from "./ColumnsCustomizer";
import WordInsertions from "../../utils/WordInsertions";
import FilterCheckNotebook from "../filters/FilterCheckNotebook";
import JsonTreeDataCreator from "../../utils/JsonTreeDataCreator";
import MetamodelStore from "../../resources/data/MetamodelStore";
import Config from "../../Config";

import '../../styles/Modal.css'

export default class ModalTableObjAttrs extends ModalComponent
{
    /**
     * After confirm the selection, table is inserted to Word document
     */
    handleFilterConfirm = () =>
    {
        const sOrderBy = this.aColumnsCustom.current.getOrderBySelection();
        const aColumnsOrder = this.aColumnsCustom.current.getColumnsOrder();
        if (0 < this.state.aSelectedObjects.length && 0 < this.state.aSelectedAttrs.length)
        {
            const aSelectedAttrs = aColumnsOrder.map(aItem =>
            {
                return this.state.aSelectedAttrs.find(aItemInner =>
                {
                    return aItemInner.name === aItem;
                });
            }).filter(aItem =>
            {
                return aItem;
            });
            const aSelectedObj = this.state.aSelectedObjects.map(aItem => aItem.name);

            WordInsertions.insertModalObjAttr(aSelectedObj, aSelectedAttrs, sOrderBy);
            this.toggleModal();
            this.setState({});
        }
    }

    /**
     * Refreshing selection of objects (get data from child component)
     * After object was selected, its notebook is shown
     */
    refreshObjectsSelection = () =>
    {
        const aSelection = this.aFilterObjRef.current.getSelection()
        this.state.aSelectedObjects = aSelection
        this.setState({});

        this.refreshAttributesSelection();
    }

    /**
     * Refreshing selection of properties (get data from child component)
     */
    refreshAttributesSelection = () =>
    {
        const aSelection = this.aFilterNotebookRef.current.getSelection();
        const aSelectionModified = this.aColumnsCustom.current.setItems(aSelection);
        this.state.aSelectedAttrs = aSelectionModified;
        this.setState({});
    }

    /**
     * Get notebooks of selected objects
     */
    getObjectsNotebooks = () =>
    {
        var aNotebook = {};
        if (this.state.aSelectedObjects)
        {
            const aObjIds = this.state.aSelectedObjects.map(aItem => aItem.extra.id);
            for (var i = 0; i < aObjIds.length; i++)
            {
                var aObjData;
                try
                {
                    aObjData = MetamodelStore.getInstance().getMetaObjectType(aObjIds[i]);
                } catch (err)
                {
                    console.error(err);
                    return aNotebook;
                }
                if (aObjData && Object.hasOwnProperty.call(aObjData, 'notebookStructure'))
                {
                    const name = Config.getLangName(aObjData);
                    aNotebook[name] = JsonTreeDataCreator.notebookData(aObjData.notebookStructure, true);
                    aNotebook[name]['id_group'] = aObjData.id;
                }
            }
        }
        return aNotebook;
    }

    render()
    {
        this.aFilterObjRef = React.createRef();
        this.aFilterNotebookRef = React.createRef();
        this.aColumnsCustom = React.createRef();

        const { isTree, sTitle, sConfirmLabel, sRejectLabel, aItems } = this.props;
        const aNotebook = this.getObjectsNotebooks();

        if (this.state.openModal)
        {
            return (
                <div className="PopupBackground">
                    <div className="PopupContent">

                        <h3 className="Modal__label">{sTitle}</h3>

                        <h4 className="Modal__label">{Config.strings.modals.modelObj.sTitleObjList.concat(":")}</h4>
                        {isTree
                            ? <FilterCheckObjTree
                                aJsonTree={aItems}
                                ref={this.aFilterObjRef}
                                onChangeCallback={this.refreshObjectsSelection.bind(this)}
                                aAddExtraData={{ id: true }}
                            />
                            : <FilterCheckObjSimple
                                aItems={aItems}
                                ref={this.aFilterObjRef}
                                onChangeCallback={this.refreshObjectsSelection.bind(this)}
                                aAddExtraData={{ id: true }}
                            />
                        }

                        <h4 className="Modal__label">{Config.strings.modals.modelObj.sTitleAttrList.concat(":")}</h4>
                        <FilterCheckNotebook
                            aNotebook={aNotebook}
                            ref={this.aFilterNotebookRef}
                            bIsModelObj={true}
                            onChangeCallback={this.refreshAttributesSelection.bind(this)}
                            aDefaultSelected={[
                                {
                                    name: "NAME",
                                    type: "ATTR"
                                }
                            ]}
                            preventRelationNotebook={false}
                        />

                        <h4 className="Modal__label">
                            <KeyboardArrowDownIcon classes={{ root: "Modal__label__icon" }} />
                            <KeyboardArrowUpIcon classes={{ root: "Modal__label__icon" }} />
                            {' '}
                            {Config.strings.modals.modelObj.sTitleColumnsList_1}
                            <RadioButtonCheckedIcon classes={{ root: "Modal__label__icon Modal__label__icon--unbalanced" }} fontSize="small" />
                            {Config.strings.modals.modelObj.sTitleColumnsList_2.concat(":")}
                        </h4>
                        <ColumnsCustomizer
                            ref={this.aColumnsCustom}
                            bSortEnable={true}
                            bShiftEnable={true}
                        />

                        <button className="wrcButton wrcButton--confirm" onClick={this.handleFilterConfirm}>
                            {sConfirmLabel}
                        </button>
                        <button className="wrcButton wrcButton--confirm" onClick={this.toggleModal}>
                            {sRejectLabel}
                        </button>

                    </div>
                </div>
            );
        } else
        {
            // clear selection when component closed
            this.state.aSelectedObjects = [];
            this.state.aSelectedAttrs = [];
            return null;
        }
    }
}
